import { useAuthContext } from "@/contexts/AuthContext";
import { useApi } from "@/hooks/useApi";
import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";

export const useLexZapCompany = () => {
  const api = useApi();
  const { user } = useAuthContext();

  return useQuery({
    queryKey: ["lexZapCompany"],
    queryFn: async () => {
      try {
        return await api.getMyLexZapCompany();
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!user?.userId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
  });
};
